import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import zxcvbn from 'zxcvbn-typescript';

export default class PasswordHelper {
  static passwordStrength: any[] = [
    {
      score: 0,
      progressBar: 5,
      color: 'warn',
      description: 'Password.Strength.VeryWeak'
    },
    {
      score: 1,
      progressBar: 25,
      color: 'warn',
      description: 'Password.Strength.Weak'
    },
    {
      score: 2,
      progressBar: 50,
      color: 'orange',
      description: 'Password.Strength.Medium'
    },
    {
      score: 3,
      progressBar: 75,
      color: 'success',
      description: 'Password.Strength.Strong'
    },
    {
      score: 4,
      progressBar: 100,
      color: 'success',
      description: 'Password.Strength.VeryStrong'
    }
  ];

  static checkPasswordStrength(password: string, userInput?: string[]) {
    const checkPasswordStrength = zxcvbn(password, userInput);
    return this.passwordStrength[checkPasswordStrength.score];
  }
}
